// Finance analytics — fire-and-forget POSTs to the backend so we can
// measure EMI-widget engagement BEFORE committing to a lender partnership.
// Anonymous session id lives in sessionStorage so we can correlate the
// funnel (view → adjust → apply-clicked → lead-submitted) without needing
// user login.

import axios from 'axios';
import { API } from './api';

const KEY = 'unisol_finance_session';

export function ensureSessionId() {
  try {
    let id = sessionStorage.getItem(KEY);
    if (!id) {
      id = `fs_${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    // sessionStorage disabled — degrade silently, we just lose funnel correlation
    return null;
  }
}

export function trackFinanceEvent({ car_id, event_type, payload }) {
  const session_id = ensureSessionId();
  const body = { car_id, event_type, session_id, payload: payload || {} };
  // Fire-and-forget — never block the UI on analytics
  axios.post(`${API}/marketplace/finance-events`, body).catch(() => {});
}
